import { Typography, Box, Grid, Button, Paper, Stack } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { lightTheme } from '../components/themes/main_theme.js';
import Header from '../components/menu/Header.tsx';
import { usePageContent } from '../data/cms.ts';
import PaypalIcon from '../images/payments/PayPal.svg'; 
import venmo from '../images/payments/venmo-icon.svg';
import paypalqr from '../images/payments/paypal-qr.png';
import venmoqr from '../images/payments/venmo-qr.png';
import venmo_name from '../images/payments/venmo-word.svg';
const Donate = () => { 
  const content = usePageContent('DONATE');
  const text = (key, fallback) => content[key] || fallback;
    return (
        <ThemeProvider theme={lightTheme}>
            <Header name={'DONATE'} />      
            <Box mx="auto" mb={6} flex={1} maxWidth={'100%'} mt={4} px={2}>
                <Typography variant="h5" color="primary" fontWeight={700} mb={2} align="center">
                   {text('heading', 'Thank you for supporting our ministry!')}
                </Typography>
                <Typography color="text.secondary" mb={4} align="center">
                    {text('intro', 'Choose your preferred donation method below.')}
                </Typography>
                <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12} md={6}>
                        <Paper elevation={3} sx={{ p: 4, borderRadius: 5, bgcolor: 'background.paper', height: '100%' }}>
                            <Typography variant="h6" fontWeight={700} color="primary" mb={2}>
                                Tax-Deductible Donations to the Ministry
                            </Typography>
                            <Typography color="text.secondary" fontSize={16}>
                                For general ministry support and projects. Tax-deductible through Venmo.
                            </Typography>
                            <Stack direction={{xs: 'column', md: 'row'}} spacing={4} alignItems="center" justifyContent="center" mt={9}>
                                <Stack direction={'column'}  alignItems="center" justifyContent="center">
                                <Typography variant="h6" fontWeight={700} color="primary" mb={1}>
                                   @SALMGuatemala
                                </Typography>
                                <Button variant="text"
                                    onClick={() => window.open('https://venmo.com/u/SALMGuatemala', '_blank')}
                                ><img src={venmo} alt="Venmo" style={{ height: 250 }} /> 
                                </Button>
                                </Stack>
                                <Stack direction={'column'} spacing={2} alignItems="center" justifyContent="center">
                                    <Typography variant="h5" textAlign="left"  fontWeight={700} color="primary" mb={2}>
                                        By Check
                                    </Typography>
                                    <Paper elevation={1} sx={{ p: 4, borderRadius: 3, textAlign: 'center', mb: 2 }}>
                                        <Typography color="primary" fontWeight={700} fontSize={18} mb={1}>
                                            Payable to:
                                        </Typography>
                                        <Typography color="text.secondary" fontWeight={600} fontSize={16} mb={2}>
                                            SALM Guatemala
                                        </Typography>
                                        <Typography color="primary" fontWeight={700} fontSize={18} mb={1}>
                                            Mail to:
                                        </Typography>
                                        <Typography color="text.secondary" fontSize={16} fontFamily="monospace">
                                            SALM c/o Toni VanSingel<br />
                                            10525 Duncan Lake Ave<br />
                                            Caledonia, MI 49316
                                        </Typography>
                                    </Paper>
                                </Stack>
                            </Stack>
                        </Paper>
                    </Grid>
                    {/* Personal Donations */}
                    <Grid item xs={12} md={6}>
                        <Paper elevation={3} sx={{ p: 4, borderRadius: 5, bgcolor: 'background.paper', height: '100%', flexWrap: 'wrap', }}>
                            <Typography variant="h6" fontWeight={700} color="primary" mb={2}>
                                Personal Donations to Alex & Ashley
                            </Typography>
                            <Typography color="text.secondary" fontSize={16} align="center">
                                For personal support for Alex and Ashley Lopez. <br />
                            </Typography>
                            <Stack spacing={2} alignItems="center" direction={{xs: 'column', sm: 'row'}}>
                                 <Button variant="text" onClick={() => window.open('https://www.paypal.me/GuateMericanA', '_blank')}>
                                    <Stack direction={'column'} spacing={2} alignItems="center" justifyContent="center">
                                        <img src={PaypalIcon} alt="Paypal" style={{ marginTop: 5}}/>
                                        <img src={paypalqr} alt="PayPal QR" style={{ width: '100%', marginTop: 25}} />
                                    </Stack>
                                </Button>
                                <Button variant="text" 
                                        onClick={() => window.open('https://venmo.com/u/elizabethlightfield', '_blank')}>
                                        <Stack direction={'column'} spacing={2} alignItems="center" justifyContent="center">
                                            <img src={venmo_name} alt="Venmo" />
                                            <img src={venmoqr} alt="Venmo Personal QR" style={{ width: '100%' }} />
                                        </Stack>
                                    </Button>
                            </Stack>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </ThemeProvider>
    );
};

export default Donate;